<template>
  <div id="componentFormPreview">
    <!-- <BlockUI :blocked="blockedDocument" :fullScreen="true">
      <ProgressSpinner v-if="blockedDocument" />
    </BlockUI> -->
    <div v-if="blockedDocument">
            <LoadingArete />
        </div> 
            <Toolbar class="" style="padding: 3px 0px !important;">
            <template #left>
                  <Button v-if="$route.params.formid != null"
                  label=""
                  icon="pi pi-arrow-left"
                  class="p-button-link p-mr-2"
                  @click="backto()"
                />
            <div class="p-mt-2" v-if="selectedform">
            <span class="p-mt-2">
              <label class="formlabel p-mr-1" ><h5>{{selectedform.name}} </h5></label>
              <label class="formlabel p-mr-1" style="font-weight: 700;color: darkgray;font-size: 15px;"> [{{ selectedform.application.name }}]</label>
            </span>
            <span class="p-mr-1 p-mr-6" ><i class="pi pi-info-circle p-mr-2" style="font-size: 15px" v-tooltip.bottom="selectedform.description"></i></span>

            <span
              :class="'customstatus ' + selectedform.statusName.toLowerCase()"
              class="p-mr-6"
              style="padding-bottom:0px !important"
            >
              <label class="formlabel">Form Status :</label>
              {{ selectedform.statusName }}
            </span>  
             </div>
            </template>

            <template #right>
                   <Button
                    v-if="isReviewer && !isAccepted && !isPublished && !isDraft"
                    label=""
                    icon="pi pi-check"
                    class="p-button-rounded p-button-primary p-mr-2"
                    @click="statusConfirmation('requestForApproval','Approved')"
                    v-tooltip.bottom="'Accept Form'"
                  />
                  <Button
                    v-if="isReviewer && !isAccepted && !isDraft && !isPublished"
                    label=""
                    icon="pi pi-ban"
                    class="p-button-rounded p-button-danger p-mr-2"
                    @click="statusConfirmation('requestForReject','Rejected')"
                    v-tooltip.bottom="'Reject Form'"
                  />
                  <Button
                    v-if="isDraft && !selectedform.application.skipApproval"
                    label=""
                    icon="pi pi-check"
                    class="p-button-rounded p-button-secondary p-mr-2"
                    @click="statusConfirmation('requestForReview','Submitted')"
                    v-tooltip.bottom="'Request for Review'"
                  />
                  <Button
                    v-if="(isPublisher && !isPublished && !isDraft && isAccepted) || (isFormCreaterAsPublisher && selectedform.application.skipApproval && !isPublished)"
                    label=""
                    icon="pi pi-upload"
                    class="p-button-rounded p-button-success p-mr-2"
                    @click="statusConfirmation('requestForPublish','Published')"
                    v-tooltip.bottom="'Publish Form'"
                  />
            </template>
        </Toolbar>
    <div class="formbuilder" v-if="!blockedDocument">
      <div class="selectedform">
        <!-- <Card style="margin-bottom: 2em">
          <template slot="title" v-if="$route.params.formid != null"> Form Preview </template>
          <template slot="content" class="m-0 p-0">
            <div class="p-grid">
              <div class="p-col-4">
                <span class="m-0 p-0">
                  <label class="formlabel"><b>Application Name </b> :</label>
                  {{ selectedform.application.name }}
                </span>
              </div>
              <div class="p-col-5">
                <span class="m-0 p-0">
                  <label class="formlabel"> <b>Form Name</b> :</label>
                  {{ selectedform.name }}
                </span>
              </div>
              <div class="p-col-3">
                <span
                  :class="
                    'customstatus ' + selectedform.statusName.toLowerCase()
                  "
                >
                  <label class="formlabel"> Form Status :</label>
                  {{ selectedform.statusName }}
                </span>
              </div>
            </div>

            <p class="m-0 p-0">
              <label class="formlabel"> <b>Form Description</b> :</label>
              {{ selectedform.description }}
            </p>
          </template>
        </Card> -->
      </div>
      <formio class="p-field p-col-12 p-md-12"
              :key="componentKey"
              v-bind:form="selectedform.schema"
              v-bind:options="options"
              v-bind:formLoad="onFormRendered"
              id="formio"
              ref="formioForm"></formio>
    </div>

    <Dialog
      v-if="displayConfirmation"
      :visible.sync="displayConfirmation"
      header="Confirmation"
      :modal="true"
      :style="{ width: '50vw' }"
    >
      <div class="confirmation-content">
        <div>
         
          <span>{{ confirmContent }}</span>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 mt-3">
            <label for="formRemark"
              >Remark<span class="p-invalid">*</span
              ></label
            >
            <Textarea
              :autoResize="true"
              rows="3"
              cols="7"
              placeholder="Form Remark"
              required="true"
              v-model="remark"
              :class="{ 'p-invalid': !remark }"
            /><span
                :class="{ 'p-invalid': !remark }"
                v-if="submitted && !remark"
                class="error-message"
                >Remarks/Comments are Required</span
              >
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation()"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="updatestatus()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import _ from "lodash";
import { Form } from "vue-formio";
export default {
  name: "formbreviewComponent",
  components: { formio: Form },
  created() {
    this.loadedForm = _.clone(this.$store.getters["forms/getSelectedForm"]);
     this.selectedFormId = this.loadedForm.id;
    this.getSelectedform();
  },
  mounted() {},
  methods: {
    async onFormRendered() {
      // console.log("Form is rendered");
    },
    getSelectedform() {
      let that = this;
     // let formid = this.formid;
     that.isFormCreaterAsPublisher = false;
     let formid = this.selectedFormId ? this.selectedFormId : this.formid;
      that.blockedDocument = true;
      that.$store
        .dispatch("forms/getSelectedform", formid)
        .then(() => {
          let response = _.clone(that.$store.getters["forms/getSelectedForm"]);
          // console.log(response);
          let application = _.clone(response.application);
          let reviewers = _.clone(application.reviewers);
          let publishers = _.clone(application.publishers);
          let userName = this.$store.getters["login/getUsername"];
          that.isReviewer = _.find(reviewers, ["name", userName])
            ? true
            : false;
          that.isPublisher = _.find(publishers, ["name", userName])
            ? true
            : false;
          that.isAccepted = _.includes(response.statusName, "Publish Pending");
          that.isPublished = _.includes(response.statusName, "Published");
          that.isDraft = _.includes(response.statusName, "Draft");
          that.blockedDocument = false;
          that.selectedform = _.clone(response);
          that.validatePublishersOrReviewrs();
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while fetching the application form",
            detail: error,
            life: 3000,
          });
        });
    },
    validatePublishersOrReviewrs() {
      let that = this;
      let loggedUser = that.$store.getters["login/getUser"];
      // console.log(loggedUser);
      if (that.selectedform !== null) {
        _.forEach(that.selectedform.application.publishers, function (item) {
          // if (item.email == that.selectedform.createdByUser.email) {
          if (item.email == loggedUser.email) {
            that.isFormCreaterAsPublisher = true;
          }
        });
      }
    },
    statusConfirmation(name,msg) {
      let that = this;
      that.toastMsg = msg;
      that.selectedAction = _.clone(name);
      that.displayConfirmation = true;
      switch (name) {
        case "requestForReview":
          that.confirmContent = `Are you sure, you want to Submit  the ${that.selectedform.name} form, If yes Enter Remarks`;
          break;
        case "requestForApproval":
          that.confirmContent = `Are you sure, you want to Accept  the ${that.selectedform.name} form, If yes Enter Remarks`;
          break;
        case "requestForReject":
          that.confirmContent = `Are you sure, you want to Reject the ${that.selectedform.name} form, If yes Enter Remarks`;
          break;
        case "requestForPublish":
          that.confirmContent = `Are you sure, you want to Publish the ${that.selectedform.name} form, If yes Enter Remarks`;
          break;
        default:
          break;
      }
    },

    closeConfirmation() {
      let that = this;
      that.submitted = false;
      that.displayConfirmation = false;
    },

    validateFrom() {
      if (this.remark) {
        this.form_error = true;
      } else {
        this.form_error = false;
      }
    },
    backto() {
      this.$router.push("/forms");
        this.blockedDocument = false; 
    },
    updatestatus() {
      let that = this;
      that.submitted = true;
      that.validateFrom();
      if (this.form_error) {
        let form = that.selectedform;
        let input = {};
        input.formid = form.id;
        input.remark = that.remark;
        let actionName = that.selectedAction;
        this.$store
          .dispatch(`forms/${actionName}`, input)
          .then(() => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Form " + that.toastMsg + " Successfully",
              life: 3000,
            });
            that.displayConfirmation = false;
            that.remark = "";
           // that.$router.push("/forms");
            that.blockedDocument = false; 
            that.getSelectedform();
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error while updating the application from",
              detail: error,
              life: 3000,
            });
          });
      }
    },
  },
  props: {},
  watch: {},
  data() {
    return {
      blockedPanel: false,
      blockedDocument: false,
      displayConfirmation: false,
      selectedform: null,
     // formid: this.$route.params.formid,
      formid: this.selectedFormId ? this.selectedFormId : this.$route.params.formid,
      confirmHeader: null,
      isReviewer: false,
      isPublisher: false,
      isAccepted: false,
      submitted: false,
      remark: null,
      isDraft: false,
      toastMsg: null,
      tooltipMsg: 'Copy form Path',
      isFormCreaterAsPublisher : false,
      options: {},
      componentKey: 0,
    };
  },
};
</script>
<style scoped>
.formbuilderbtns {
  text-align: center;
}
.formbuilder {
  max-height: 600px;
  min-height: 600px;
  overflow: hidden scroll;
  padding: 1%;
  background: #ffffff;
}
.active {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
  border: #c8e6c9 !important;
}
</style>
